module.exports = __webpack_public_path__ + "img/unlock.32a5418b.svg";